module.exports = __webpack_public_path__ + "static/media/22.78569033.mp3";